/**
 * @description 新功能引导相关配置
 */
import { shouldDisableNetwork } from '@src/slide/infrastructure/module/dependent/socket';

// 需要展示新功能引导的配置
export const whatsNewConfig = {
    effect: { onProdDate: '2020/09/01' },
    'insert-menu-item': { onProdDate: '2021/03/11' },
    'insert-iframe': { onProdDate: '2020/12/01' },
    'insert-iframe-item-1': { onProdDate: '2020/12/01' },
    'insert-iframe-item-2': { onProdDate: '2020/12/01' },
    'insert-iframe-item-3': { onProdDate: '2020/12/01' },
    // Todo: 上线前需要变更生效时间
    'insert-item-with-latex': { onProdDate: '2021/03/11' }, // 插入Latex公式
};

/**
 * 判断是否应该展示新功能引导
 * @param {String} newType 类型（为whatsNewConfig中的值）
 * @param {String} lastingDays 展示新功能红点的天数，默认为7天
 * @return {Boolean} true or false
 */
export const shouldShowNewFeatureIntroRedPoint = (newType, lastingDays = 7) => {
    // 免登录纯净版客户端不展示红点相关功能
    if (shouldDisableNetwork()) {
        return false;
    }
    const newFeature = whatsNewConfig[newType];
    if (!newFeature) return false;
    const now = Date.now();
    const onProd = Date.parse(newFeature.onProdDate);

    // 当前时间与设定时间的差值
    const timeSlot = Math.floor((now - onProd) / 86400000);

    // 时间差值小于零: 设定时间在当前时间之后，用于预设显示的时间，未到设定时间前不显示红点
    // 时间差值大于展示天数：按照正常逻辑不显示红点
    if (timeSlot < 0 || timeSlot >= lastingDays) return false;

    const redPointState = localStorage.getItem(`${newType}_red_point`);
    return !redPointState || redPointState === 'true';
};
